<div class="container p-3">
    <h1 class="mb-0">Assistant Dashboard</h1>
    <h4 class="fw-light mb-0">This section will allow you to see how well your assistant performs</h4>

    <div class="row mt-5 mb-3">
        <mat-form-field appearance="outline" class="mx-auto w-50">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" [formControl]="startDateRangePickerValue">
                <input matEndDate placeholder="End date" [formControl]="endDateRangePickerValue">
            </mat-date-range-input>
            <mat-hint>Filter by date range</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>

    <mat-divider class="mt-4 mb-4"></mat-divider>

    <!-- CALL OVERVIEW COMPONENT -->
    <div class="row" *ngIf="aiAgentDashboard.length > 0 && !isLoading">
        <h1>Overview:</h1>
        <div class="col-lg-4 mb-4" *ngFor="let data of aiAgentDashboard">
            <div class="mat-elevation-z2 rounded p-3 h-100">
                <p class="text-muted">{{data.title}}</p>
                <h1 class="fw-bold">{{data.data}}</h1>
            </div>
        </div>
    </div>

    <div class="container h-100 d-flex align-items-center p-5" *ngIf="isLoading">
        <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
    </div>

    <div class="row mt-4" *ngIf="aiAgentDashboard.length == 0">
        <p class="text-center">No data to display since you haven't made any calls in this date range</p>
    </div>

    <mat-divider class="mb-4"></mat-divider>

    <!-- MOST RECENT CALLS COMPONENT -->
    <div class="row" *ngIf="mostRecentCalls.length > 0">
        <h1>Most recent calls in date range:</h1>
        <div class="col-lg-6" *ngFor="let cl of mostRecentCalls; let i = index">
            <div class="mat-elevation-z2 rounded p-3 m-2" *ngIf="i < 5">
                <p>{{cl.time}}</p>

                <div class="d-flex">
                    <mat-icon>phone</mat-icon>
                    <p>{{cl.phone}}</p>
                </div>

                <mat-divider class="mt-3 mb-3"></mat-divider>

                <button mat-raised-button class="d-block mx-auto" (click)="onViewAllClicked()">View All</button>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="mostRecentCalls.length == 0">
        <p class="text-center">No data to display since you haven't made any calls in this date range</p>
    </div>
</div>